<template>
  <v-card-text style="max-height: 440px; padding: 0;">
    <v-text-field
      v-if="displaySearchField"
      :placeholder="translate('ui_dialog_search_quick_select')"
      v-model="searchString"
    ></v-text-field>
    <div style="display: flex;">
          <div v-if="this.predefinedResourcesGroups.length" style="width: 30%;">
            <v-list nav dense color="transparent">
              <v-list-item-group
                style="max-height: 250px; overflow: scroll;"
                v-model="selectedGroup"
                active-class="blue--text"
              >
                <v-list-item
                  v-for="(group, i) in this.predefinedResourcesGroups"
                  :key="i"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ group.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

              </v-list-item-group>
            </v-list>
          </div>

          <div style="width: 100%;">
            <v-list
              style="margin: 0px;
              padding: 0px;
              height: 250px;
              overflow-x: hidden;"
              class="suggested-resources"
            >
              <v-list-item-group>
                <v-list-item
                  v-for="(resource, i) in this.predefinedResources"
                  :key="i"
                  style="min-height: initial;"
                  @click="increment(resource)"
                >
                  <v-list-item-action
                    style="align-self: center; margin-right: 16px;"
                  >
                    <v-btn
                      fab
                      outlined
                      x-small
                      style="text-transform: initial; width: 26px; height: 26px;"
                      :style="[getCount(resource) > 0 ? {backgroundColor: '#1976d2', color: '#fff'} : {backgroundColor: '#fff', color: '#1976d2'}]"
                    >
                      <v-icon
                        v-if="getCount(resource) === 0"
                        :title="translate('ui_add_btn')"
                        style="font-style: initial; font-size: 16px;"
                      >
                        mdi-plus
                      </v-icon>
                      <v-icon
                        v-if="getCount(resource) > 0"
                        :title="translate('ui_add_btn')"
                        style="font-style: initial; font-size: 16px;"
                      >
                        x{{ getCount(resource) }}
                      </v-icon>
                    </v-btn>
                  </v-list-item-action>
                  <v-list-item-content style="cursor: pointer;">
                    <v-list-item-title
                      style="display: flex; justify-content: space-between;"
                    >
                      <div
                        :title="resource.name"
                        v-html="highlightSearchString(resource)"
                      ></div>
                    </v-list-item-title>
                    <v-card-subtitle
                      v-if="resource.formula"
                      style="padding: 0; text-align: left; font-size: 12px;"
                    >
                      {{ resource.formula.name[$store.state.activeTemplate.language] || resource.formula.name}}
                    </v-card-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </div>
        </div>
  </v-card-text>
</template>

<script>

// mixins
import Mixin from '@/mixins/mixin';

export default {
  components: {},
  props: {
    predefinedResources: Array,
    selectedResources: Array,
  },
  mixins: [Mixin],
  data() {
    return {
      selectedResourceIndexes: [],
      selectedGroup: null,
      searchString: '',
      displaySearchField: false,
    };
  },
  methods: {
    getCount(resource) {
      const selectedResource = this.selectedResources.find((r) => r.id === resource.id);
      return selectedResource ? selectedResource.count : 0;
    },
    increment(resource) {
      const selectedResource = this.selectedResources.find((r) => r.id === resource.id);
      if (!selectedResource) {
        this.selectedResources.push({
          id: resource.id,
          name: resource.name,
          rel: resource.rel,
          formula: resource.formula && JSON.parse(JSON.stringify(resource.formula)),
          bundle: resource.bundle,
          count: 1,
        });
      } else {
        // eslint-disable-next-line
        if (selectedResource.count === 3) {
          const selectedResourceIndex = this.selectedResources.findIndex((r) => r.id === resource.id);
          this.selectedResources.splice(selectedResourceIndex, 1);
        } else {
          selectedResource.count += 1;
        }
      }
      this.$emit('updateSelectedResources', this.selectedResources);
    },
    highlightSearchString(resource) {
      let result = resource.name;
      if (this.searchString.length) {
        const re = new RegExp(`(?<!>)${this.searchString}`, 'ig');
        // eslint-disable-next-line
        result = result.replace(re, (match) => {
          return `<span style="color: orangered;">${match}</span>`;
        });
      }
      return result;
    },
  },
  computed: {
    predefinedResourcesGroups() {
      return false;
      // return [{
      //   id: 'all',
      //   name: 'All',
      // }, {
      //   id: 'restaurant',
      //   name: 'Restaurant',
      // }];
    },
  },
};
</script>
